import { createFileRoute, Link, notFound } from "@tanstack/react-router";
import { ContentPage } from "../components/content/ContentPage";
import { ArticleBody } from "../components/content/ArticleBody";
import { RevealImage } from "../components/landing/RevealImage";
import { WaitlistForm } from "../components/landing/WaitlistForm";
import { findArticle, formatArticleDate } from "../content/noutati";

const SITE_URL = "https://suuper.ro";

export const Route = createFileRoute("/noutati/$slug")({
  loader: ({ params }) => {
    const article = findArticle(params.slug);
    if (!article) throw notFound();
    return article;
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const url = `${SITE_URL}/noutati/${loaderData.slug}`;

    return {
      meta: [
        { title: `${loaderData.title} — suuper` },
        { name: "description", content: loaderData.description },
        { name: "robots", content: "index, follow" },
        { property: "og:type", content: "article" },
        { property: "og:title", content: loaderData.title },
        { property: "og:description", content: loaderData.description },
        { property: "og:url", content: url },
        { property: "article:published_time", content: loaderData.publishedAt },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: ArticlePage,
});

function ArticlePage() {
  const article = Route.useLoaderData();

  return (
    <ContentPage
      title={article.title}
      meta={`${formatArticleDate(article.publishedAt)} · ${article.readMinutes} min de citit`}
    >
      {/* `priority`: imaginea e ținta morph-ului dinspre card, deci trebuie să
          fie deja la locul ei. O animație proprie de intrare s-ar suprapune
          peste tranziție și ar citi ca o tresărire. */}
      <RevealImage
        name={article.image}
        ratio="16/9"
        sizes="(max-width: 768px) 100vw, 720px"
        parallax={false}
        priority
        viewTransitionName={`article-${article.slug}`}
        className="mb-10 w-full rounded-[28px] shadow-lg"
      />

      <ArticleBody blocks={article.blocks} />

      {/* Sfârșitul articolului e punctul natural de conversie. Formularul stă
          chiar aici, nu un link către altă pagină: un pas în minus. */}
      <aside className="relative isolate mt-16 overflow-hidden rounded-[32px] bg-primary px-6 py-10 sm:px-10 sm:py-12">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -top-24 left-1/2 h-72 w-[560px] max-w-[130%] -translate-x-1/2 rounded-full bg-white/20 blur-3xl"
        />

        <div className="relative mx-auto max-w-md text-center">
          <p className="text-[11px] font-bold tracking-[0.14em] text-white/70">
            ACCES ÎNAINTE DE LANSARE
          </p>

          <p className="mt-4 text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl">
            Hai în suuper club.
          </p>

          <p className="mt-3 text-white/80 leading-relaxed">
            Lasă-ți emailul și afli printre primii când comunitatea deblochează
            un preț nou. Gratuit, fără card.
          </p>

          <div className="mt-8 rounded-[24px] bg-white p-5 text-left shadow-xl sm:p-6">
            <WaitlistForm source={`noutati-${article.slug}`} chrome="bare" />
          </div>
        </div>
      </aside>

      <p className="mt-10">
        <Link to="/noutati" className="font-medium text-primary hover:underline">
          ← Toate noutățile
        </Link>
      </p>
    </ContentPage>
  );
}
